
import { Tip } from "@/components/fun-ui/Tip";
import { HelpCircleIcon } from "@/components/fun-ui/icons";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
import { cn } from "@/lib/utils";
import { useConsumptions } from "@/stores/appStore";
import { useEffect, useMemo } from "react";

type AmountsToTimesProps = {
  amounts: number;
  index: number;
  counts: number;
  coupons: number;
}

export function AmountsToTimes({
  amounts,
  index,
  counts,
  // 优惠券张数
  coupons = 0,
}: AmountsToTimesProps) {
  const {
    consumptions,
    initialConsumptions,
  } = useConsumptions();

  const consumptionsList = useMemo(() => {
    return Object.keys(consumptions || {});
  }, [consumptions]);

  useEffect(() => {
    initialConsumptions();
  }, [initialConsumptions]);

  return (
    <div className="flex flex-col">
      <div className="px-16 pt-11 pb-8 bg-background rounded-xl mt-11 relative">
        <div className="text-2xl font-medium">飞豆数量对应 AI 能力使用次数</div>
        <Table className="mt-7">
          <TableHeader>
            <TableRow
              className="bg-[#F5F7FF]/70 hover:bg-[#F5F7FF] rounded-xl text-foreground border-none"
            >
              {
                [
                  'AI 能力',
                  '使用消耗',
                  '可使用次数'
                ].map((title) => (
                  <TableHead
                    key={title}
                    className={cn(
                      "text-foreground text-base font-medium border-none px-6 py-3.5 rounded-l-xl",
                      "first:rounded-l-xl last:rounded-r-xl",
                    )}
                  >
                    {title}
                  </TableHead>
                ))
              }
            </TableRow>
          </TableHeader>
          <TableBody>
            {
              consumptionsList.map((key) => {
                const {
                  price: _price,
                  priceBeforeDiscount,
                  desc,
                  unit = '次',
                  consume,
                  bit,
                  firstDiscount,
                } = consumptions![key];
                // 价格取一下折扣价，没有取原价
                const price = priceBeforeDiscount || _price;
                if (!consume) {
                  return null;
                }
                let timesString = (amounts / (Number(price) * Number(bit?.count ?? 1))).toFixed(0);
                let counts = amounts;
                if (coupons && !!firstDiscount) {
                  counts = counts + firstDiscount;
                  const timesWithCoupons = (Number(timesString) + coupons).toFixed(0);
                  if (Number(timesString) > 0) {
                    timesString = `${timesString} - ${timesWithCoupons}`;
                  } else {
                    timesString = timesWithCoupons;
                  }
                }
                const timesCellLabel = `${counts} 飞豆 = ${timesString} ${unit}`;
                const cells = [
                  desc,
                  `${price} 飞豆 / ${bit?.unit ?? unit}`,
                  <div key={`times_${key}`} className="flex items-center space-x-2">
                    <span>{timesCellLabel}</span>
                    {
                      !coupons && bit ? <Tip label={bit.label} side="right"><HelpCircleIcon /></Tip> : null
                    }
                  </div>,
                ];
                return (
                  <TableRow
                    key={key}
                    className="border-none"
                  >
                    {
                      cells.map((label, index) => (
                        <TableCell
                          key={key + index}
                          className="border-none px-6 py-3.5 text-muted-foreground text-base w-1/3"
                        >
                          {label}
                        </TableCell>
                      ))
                    }
                  </TableRow>
                )
              })
            }
          </TableBody>
        </Table>
        <div className="absolute top-0 -left-3.5 -right-3.5">
          <div className={cn(
            "absolute top-0 -translate-y-full",
            "transition-all	duration-500",
          )} style={{
            width: `${Math.floor(100 / counts)}%`,
            left: `${Math.floor(100 / counts) * index}%`
          }}>
            <div className="flex justify-center">
              <svg fill="none" version="1.1" width="32.589744567871094" height="21.17250633239746" viewBox="0 0 32.589744567871094 21.17250633239746">
                <g>
                  <path d="M0,21.1725L32.5897,21.1725L18.6723,3.08906C17.4714,1.52869,15.1183,1.52869,13.9174,3.08906L0,21.1725Z" fill="#FFFFFF" fillOpacity="1" />
                  <path d="M0,21.1725L32.5897,21.1725L31.8201,20.1725L18.6723,3.08906C17.4714,1.52869,15.1183,1.52869,13.9174,3.08906L0.769624,20.1725L0,21.1725ZM30.5582,20.1725L2.0315,20.1725L14.7099,3.69897Q15.3104,2.91878,16.2949,2.91878Q17.2794,2.91878,17.8798,3.69897L30.5582,20.1725Z" fillRule="evenodd" fill="#FFFFFF" fillOpacity="1" />
                </g>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-2.5 text-xs text-annotation-foreground w-full text-right">*赠送飞豆有效期1年，购买飞豆有效期3年</div>
    </div>
  )
}